import { render, staticRenderFns } from "./SatgasReportTab.vue?vue&type=template&id=37622740"
import script from "./SatgasReportTab.vue?vue&type=script&lang=js"
export * from "./SatgasReportTab.vue?vue&type=script&lang=js"
import style0 from "./SatgasReportTab.vue?vue&type=style&index=0&id=37622740&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports